import { createContext, useContext, useState } from 'react';

export enum SweepCanvasSelectionMode {
  panOnDrag = 'PAN_ON_DRAG',
  selectOnDrag = 'SELECT_ON_DRAG',
}
interface CanvasControlsCtxType {
  selectionMode: SweepCanvasSelectionMode;
  setSelectionMode: React.Dispatch<React.SetStateAction<SweepCanvasSelectionMode>>;
  initialized: boolean;
}

export const CanvasControlsCtx = createContext<CanvasControlsCtxType>({
  selectionMode: SweepCanvasSelectionMode.panOnDrag,
  setSelectionMode: () => {},
  initialized: false,
});

export const CanvasControlsCtxProvider = ({ children }: { children: React.ReactNode }) => {
  const [selectionMode, setSelectionMode] = useState<SweepCanvasSelectionMode>(
    SweepCanvasSelectionMode.panOnDrag,
  );

  return (
    <CanvasControlsCtx.Provider value={{ selectionMode, setSelectionMode, initialized: true }}>
      {children}
    </CanvasControlsCtx.Provider>
  );
};

export const useCanvasControlsCtx = () => {
  const ctx = useContext(CanvasControlsCtx);
  if (!ctx) {
    throw new Error('CanvasControlsCtx not initialized');
  } else if (!ctx.initialized) {
    throw new Error('CanvasControlsCtx not initialized');
  }
  return ctx;
};
